import styled from 'styled-components'

const Container = styled.div`
  margin-bottom: 32px;
  & b {
    font-weight: bold;
  }
`

const SubHeading = styled.p`
  &&& {
    font-weight: bold;
    margin-bottom: 16px;
  }
`

const TombstoneSubText = styled.div`
  margin-top: 16px;
`
const Heading = styled.div`
  color: ${props => props.theme.color.palette['brand-1']};
`

export { Container, Heading, SubHeading, TombstoneSubText }
